import { uploadthingFileUrl } from '@travel-planner/uploadthing/client';
import { trpc } from '@/shared/api/trpc';
import { getSubdomain } from '../lib/get-subdomain';

/**
 * Resolve per-organization sign-in branding from the current subdomain.
 *
 * On a tenant host (`svt.xthory.com`) this fetches the org's public branding
 * (name + logo) so the sign-in page shows that org's logo. On a bare domain
 * or `localhost` there's no subdomain, the query stays disabled, and callers
 * fall back to the default XTHORY/Eleggia branding. Mirrors legacy
 * `useGetOrganizationBranding`.
 */
export const useOrganizationBranding = () => {
  const subdomain = getSubdomain();

  const query = trpc.organizations.findBySubdomain.useQuery(
    { subdomain },
    {
      enabled: subdomain.length > 0,
      retry: false,
      staleTime: Number.POSITIVE_INFINITY,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  const branding = query.data ?? null;
  const logoUrl = branding?.logo ? uploadthingFileUrl(branding.logo) : null;

  return {
    subdomain,
    organizationName: branding?.name ?? null,
    logoUrl,
    isLoading: query.isLoading,
  };
};
